/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(function() {
  // if(window.location.hash === '#opencartdrawer') {
  //     document.getElementById('mini-cart').open = true;
  //     history.pushState("", document.title, window.location.pathname + window.location.search);
  //   }
  $('.your-comfort_wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $(window).on('resize', function() {
      $('.carousel').slick('resize');
  });

  $('.multi-col-inr-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $('.dream_sto-vdo-img-inr').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.multi-col-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#f9f7fb"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#c8bed3" fill-rule="evenodd"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#f9f7fb"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#c8bed3" fill-rule="evenodd"/></svg></button>',
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('body').on('change','.product .layer_selector select', function(){
    var _this = $(this);
    var url = $(this).val();  
    window.location.href = url; 
  });

  $('body').on('click','.product .sizeguide-modal .tab_toggler .tab_selector', function(){
    var _this = $(this);
    _this.closest('.tab_flex_wrap').find('.tab_selector').removeClass('active');
    _this.addClass('active');
    var url = $(this).attr('data-taburl');
    $.get(url, function( data ) {            
      _this.closest('.model_content_wrapper').find('.tab-content-main').html($(data).find('.sizeguide-modal  .model_content_wrapper .tab-content-main').html());      
    }); 
  });
  
  function selectvalue(selector){ 
    if(selector.find('.variant_seperator[data-index="0"]').val() != null && selector.find('.variant_seperator[data-index="1"]').val() != null){
      $('.product__info .default_price_set').remove();
      var value1 = selector.find('.variant_seperator[data-index="0"]').val().replace('x',' x ');
      var value2 = selector.find('.variant_seperator[data-index="1"]').val();
      return value1 + ' x ' + value2;        
    }else{
      return null;
    }    
  }

  $('body').on('change','.product .categorywise_selector .variant_seperator', function(){
    var selectionvalue = selectvalue($(this).closest('.categorywise_selector'));
    if(selectionvalue == null){
      $('.product-form__add-button').attr('type','button').removeAttr('data-product-add-to-cart-button','').attr('disabled','');
      return;
    }
    var varproductData = JSON.parse(document.getElementById('productJson').textContent);
    var selectedvariant = varproductData.product.variants.filter(variant => {
      return variant.title == selectionvalue.toUpperCase()
    })
    console.log(selectedvariant);
    if(selectedvariant[0]){
      if(selectedvariant[0].available){
        console.log('ifff')
        $('.product-form__add-button').attr('type','submit').attr('data-product-add-to-cart-button','').removeAttr('disabled');
        var btntext = $('.product-form__add-button').attr("data-button-content")
      }else{
        console.log('elsss')
        $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
        var btntext = window.themeVariables.strings.productFormSoldOut
      }
    }else{
      console.log('eslslslslsl')
      $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
      var btntext = window.themeVariables.strings.productFormUnavailable
    }
    $('.product-form__add-button').find('.regular_text').text(btntext);
    $(this).closest('.custom_selector').find('.selector_wrapper').val(selectionvalue).trigger('change');
    $('[name="properties[Custom size]"]').remove();
  });

  $('body').on('click','.product .item_toggler .item_link', function(){
    $(this).closest('.item_main').find('.item_link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('product-variants').find('.categorywise_selector').removeClass('active').addClass('hidden-phone hidden-tablet-and-up')
    $(this).closest('product-variants').find('.categorywise_selector[data-currentcat="'+$(this).attr('data-value')+'"]').addClass('active').removeClass('hidden-phone hidden-tablet-and-up');
    var selectionvalue = selectvalue($(this).closest('product-variants').find('.categorywise_selector.active'));  
    if(selectionvalue == null){
      $('.product-form__add-button').attr('type','button').removeAttr('data-product-add-to-cart-button','').attr('disabled','');
      return;
    }
    var varproductData = JSON.parse(document.getElementById('productJson').textContent);
    var selectedvariant = varproductData.product.variants.filter(variant => {
      return variant.title == selectionvalue.toUpperCase()
    })
    console.log(selectedvariant);
    if(selectedvariant[0]){
      if(selectedvariant[0].available){
        $('.product-form__add-button').attr('type','submit').attr('data-product-add-to-cart-button','').removeAttr('disabled');
        var btntext = $('.product-form__add-button').attr("data-button-content")
      }else{
        $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
        var btntext = window.themeVariables.strings.productFormSoldOut
      }
    }else{
      $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
      var btntext = window.themeVariables.strings.productFormUnavailable
    }
    $('.product-form__add-button').find('.regular_text').text(btntext);
    
    $(this).closest('product-variants').find('.selector_wrapper').val(selectionvalue).trigger('change');
    $('[name="properties[Custom size]"]').remove();
  });

  $('body').on('change','.mattress_product_form .custom_selector .unit_selector select', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('product-variants').find('.categorywise_selector').each(function(){      
      $(this).find('select').each(function(i, e){
        $(this).find('option').each(function(i, e){
          if($(e).val() != ''){
            var txtval = $(e).val().toLowerCase().replaceAll(" ", "").replaceAll('Inches','').trim();
            if(txtval.indexOf('x') > -1){
              var splittext = txtval.split('x');
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(splittext[0]) / 12;
                var mainval2 = parseInt(splittext[1]) / 12;
                var feetvalue = `${mainval1.toFixed(2)} Ft x ${mainval2.toFixed(2)} Ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(splittext[0]);
                var mainval2 = 2.54 * parseInt(splittext[1]);
                var feetvalue = `${mainval1.toFixed(2)} CM x ${mainval2.toFixed(2)} CM`;
              }else{
                var mainval1 = parseInt(splittext[0]);
                var mainval2 = parseInt(splittext[1]);
                var feetvalue = `${mainval1} Inches x ${mainval2} Inches`;
              }
                              
            }else{
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(txtval) / 12;
                var feetvalue = `${mainval1.toFixed(2)} Ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(txtval);
                var feetvalue = `${mainval1.toFixed(2)} CM`;
              }else{
                var mainval1 = parseInt(txtval);
                var feetvalue = `${mainval1} Inches`;
              }       
            }
            $(e).text(feetvalue); 
          }          
        });
      });
    });
  });

  $('body').on('click','#custom-size-popup .customsize_selector', function(){  
    var customvalues = [];
    var customvaluesH = [];
    var _this = $(this);
    $(this).closest('.model_content_wrapper').find('.custom-size-field-wp .input').each(function(i,e){
      customvalues.push($(this).find('input,select').val());    
    });
    var seperate = customvalues.join(' x ').split(' x ');
    var l = seperate[0], w = seperate[1], h = seperate[2];
    l = parseFloat(l);
    w = parseFloat(w);
    h = parseFloat(h);
    if (l == '' || w == '' || h == '') {
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.blank_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else if (/^-?\d+(\.\d+)?$/.test(l) == false || /^-?\d+(\.\d+)?$/.test(w) == false) {      
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.alphabet_err_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else if (l < 10 || w < 10 || l > 95 || w > 95) {
      // alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.oversize_msg).fadeIn().delay(3000).fadeOut('fast');          
    } else if (String(l).indexOf('.') > -1 || String(w).indexOf('.') > -1){
      // alert('Please ensure that you have added your dimensions without any decimals');
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.decimal_val_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else {
      var prddata = JSON.parse($('#productJson').html());
      var filteredSizeArr;
      filteredSizeArr = prddata.product.variants.filter(function(v){
        // if(v['available']){
          var sizeOpt = v['title'].toLowerCase().replaceAll(' ','').trim();
          var sizeOptArr = sizeOpt
          .trim()
          .split('x');
          var v_len = parseFloat(sizeOptArr[0].trim());
          var v_width = parseFloat(sizeOptArr[1].trim());
          var v_height = parseFloat(sizeOptArr[2].trim());                  
          return v_len == l && v_width == w && v_height == h ;
        // } else {
        //   return 0;
        // }
      });
      if(filteredSizeArr.length == 0){
        filteredSizeArr = prddata.product.variants.filter(function(v){
          // if(v['available'] && filteredSizeArr.length == 0){
            var sizeOpt = v['title'].toLowerCase().replaceAll(' ','').trim();
            var sizeOptArr = sizeOpt
            .trim()
            .split('x');
            var v_len = parseFloat(sizeOptArr[0].trim());
            var v_width = parseFloat(sizeOptArr[1].trim());
            var v_height = parseFloat(sizeOptArr[2].trim());                  
            return v_len >= l && v_width >= w && v_height >= h ;
          // } else {
          //   return 0;
          // }
        });
      }
      if(filteredSizeArr.length == 0){
        $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
        return false;
      }
      var foundvallw = '', foundvalh = '', foundedelement, foundvar = 0;
      var sizeOpt = filteredSizeArr[0]['title'].toLowerCase().replaceAll(' ','').trim();
      var sizeOptArr = sizeOpt
      .trim()
      .split('x');
      var finall = parseFloat(sizeOptArr[0].trim());
      var finalw = parseFloat(sizeOptArr[1].trim());
      var finalh = parseFloat(sizeOptArr[2].trim());
      $('.product product-variants .categorywise_selector').each(function(){
        // var innl = [], innw = [], innh = [];   
        if($(this).find('.select.variant_seperator:eq(0) option[value="'+finall +'x'+finalw+'"]').length > 0 &&
          $(this).find('.select.variant_seperator:eq(1) option[value="'+finalh +'"]').length > 0){
            foundvallw = finall +'x'+finalw;
            foundvalh = finalh;
            foundedelement = $(this);
            return false; 
          }        
      });
      
      if(foundedelement){
        foundedelement.find('.select[data-index="0"]').val(foundvallw).trigger('change');
        foundedelement.find('.select[data-index="1"]').val(foundvalh).trigger('change');
        foundedelement.closest('product-variants').find('.item_main .item_link').removeClass('active');
        foundedelement.closest('product-variants').find('.item_toggler .item_link[data-value="'+ foundedelement.closest('.categorywise_selector').attr('data-currentcat') +'"]').addClass('active');
        foundedelement.closest('product-variants').find('.categorywise_selector').removeClass('active').addClass('hidden-phone hidden-tablet-and-up')
        foundedelement.addClass('active').removeClass('hidden-phone hidden-tablet-and-up');
        _this.closest('#custom-size-popup').removeAttr('open');
        $('.custom-size-selector .button-content-main').find('.selected_msg').remove();
        $('.custom-size-selector .button-content-main').append('<span class="selected_msg">size selected - '+l+'X'+w+'X'+h+'</span>');
        var formid = $('.select#selector_wrapper_custom').attr('form');
        $('.select#selector_wrapper_custom').after('<input type="hidden" form="'+formid+'" name="properties[Custom size]" value="'+l+'X'+w+'X'+h+'">');
        $('.afteratc.custom-size-form-error').remove();
        if($('#AddToCart[data-product-add-to-cart-button]').attr('disabled')){
          $('#AddToCart[data-product-add-to-cart-button]').after('<div class="afteratc custom-size-form-error">Your selected custom size is not available</div>');
          setTimeout(function(){
            $('.afteratc.custom-size-form-error').remove();
          }, 5000);
          // $('#AddToCart[data-product-add-to-cart-button]').trigger('click');
        }else{
          $('#AddToCart[data-product-add-to-cart-button]').trigger('click');
        }
        
      }else{
        $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
      }
    }
    
  });

  $('body').on('change','#sizeguide-popup .sizeguide-modal .size_measurement select', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('.tab-content-main').find('.size_value').each(function(){      
      // $(this).find('select').each(function(i, e){
      //   $(this).find('option').each(function(i, e){
          var txtval = $(this).attr('data-val').toLowerCase().replaceAll(" ", "").replaceAll('Inches','').trim();
          if(txtval.indexOf('x') > -1){
            var splittext = txtval.split('x');
            if(_this.val() == 'ft'){
              var mainval1 = parseInt(splittext[0]) / 12;
              var mainval2 = parseInt(splittext[1]) / 12;
              var mainval3 = parseInt(splittext[2]) / 12;
              var feetvalue = `${mainval1.toFixed(2)} x ${mainval2.toFixed(2)} x ${mainval3.toFixed(2)} Ft`;
            }else if(_this.val() == 'cm'){
              var mainval1 = 2.54 * parseInt(splittext[0]);
              var mainval2 = 2.54 * parseInt(splittext[1]);
              var mainval3 = 2.54 * parseInt(splittext[2]);
              var feetvalue = `${mainval1.toFixed(2)} x ${mainval2.toFixed(2)} x ${mainval3.toFixed(2)} CM`;
            }else{
              var mainval1 = parseInt(splittext[0]);
              var mainval2 = parseInt(splittext[1]);
              var mainval3 = parseInt(splittext[2]);
              var feetvalue = `${mainval1} x ${mainval2} x ${mainval3} Inches`;
            }
                            
          }else{
            if(_this.val() == 'ft'){
              var mainval1 = parseInt(txtval) / 12;
              var feetvalue = `${mainval1.toFixed(2)} Ft`;
            }else if(_this.val() == 'cm'){
              var mainval1 = 2.54 * parseInt(txtval);
              var feetvalue = `${mainval1.toFixed(2)} CM`;
            }else{
              var mainval1 = parseInt(txtval);
              var feetvalue = `${mainval1} Inches`;
            }       
          }
          $(this).text(feetvalue);
      //   });
      // });
    });
  });
  
  // Set the date we're counting down to
  $('body').find('.countdown_timer').each(function(i, v){
    var _this = this;
    var time = $(this).attr('data-time');
    var countDownDate = new Date(time).getTime();
  
    // Update the count down every 1 second
    var x = setInterval(function() {
  
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // Display the result in the element with id="demo"
      if(days > 1){
        var daytext = 'days';
      }else{
        var daytext = 'day';
      }
      $(_this).html(days + " "+ daytext + ' ' + hours + " hrs " + minutes + " mins " + seconds + " sec");
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        $(_this).closest('.offer_endsin').hide();
      }
    }, 1000);
  
  });  

  var width = $(window).outerWidth();
    console.log(width)
    if(width<=999){
      $('body').on('click','.footer__item--links .footer__item-title', function(){
      $(this).toggleClass('active');
      $(this).next('.footer__item-content').slideToggle();
      }) 
    } 

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  // $('body').on('change','#discount_code',function(){
  //   var val = $(this).val();
  //   if(val != 'none'){
  //     $('.discount-code-apply-wrapper').find('.discount-code').val(val);
  //     $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
  //   }else{      
  //     $('.discount-code-apply-wrapper').find('.success-msg').hide();
  //     $('.discount-price-wrapper').find('.discount-price,.total-price,.shipping-total').hide();
  //     $('.err-msg').hide();
  //     $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.');
  //     setCookie('discountcode',false,-1);      
  //   }
  // });
  
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

 
  // $('body').on('click','#discount_code_btn',function(e){
  //   e.preventDefault();
  //   var _this = $(this);
  //   _this.addClass('loading');
  //   $('[action="/cart"]').find('.form_discount').remove();
  //   if(_this.closest('.cart-discont-input').find('.discount-code').val() != ''){
  //     _this.attr('disabled','disabled');
  //     $.getJSON('/cart.js', function (cdata) {
  //       $.getJSON('/payments/config', function (data) {                      
  //           var main_check = {}, body_obj = {};
  //           body_obj.discount_code = _this.closest('.cart-discont-input').find('.discount-code').val();
  //           body_obj.line_items = cdata.items;
  //           body_obj.presentment_currency = $('body').attr('data-currency');
  //           main_check.checkout = body_obj;
  //           main_check = JSON.stringify(main_check);
  //           $.ajax({
  //             type: "POST",
  //             url: "/wallets/checkouts/",
  //             dataType: 'json',
  //             async: false,
  //             data: main_check,
  //             headers: {
  //               "Content-Type": "application/json",
  //               "authorization": "Basic " + btoa(data.paymentInstruments.accessToken),
  //               "cache-control": "no-cache",
  //               "pragma": "no-cache"
  //             },
  //             credentials: "include",
  //             error: function (response){
  //                 $('.discount-code-apply-wrapper').find('.success-msg').hide();
  //                 // $('.discount-price-wrapper').find('.discount-price,.total-price,.shipping-total').hide();
  //                 $('.err-msg').hide();
  //                 console.log(response)
  //                 if(response.responseJSON){                    
  //                   if(response.responseJSON.errors.discount_code){
  //                     if(response.responseJSON.errors.discount_code[0].code == "discount_not_found"){
  //                      $('.err-msg').show().html('This coupon code has expired.');
  //                     }
  //                   }else if(response.responseJSON.errors.applied_discount.code){
  //                    $('.err-msg').show().html(response.responseJSON.errors.applied_discount.code[0].message);
  //                   }else{
  //                    $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.'); 
  //                   }                  
  //                 }else{
  //                   $('.err-msg').show().html('Something went wrong, please try after some time.'); 
  //                 }
  //                 _this.removeAttr('disabled');                                    
  //                 _this.removeClass('loading');                  
  //                 setCookie('discountcode',false,-1);                     
  //             },
  //             success: function (data) {                    
  //               if(data.checkout.applied_discounts.length > 0 && data.checkout.applied_discount.applicable){
  //                 console.log('data',data);  
  //                 $('.err-msg').hide();                  
  //                 $('[action="/cart"]').prepend('<input class="form_discount" type="hidden" name="discount" value="'+ data.checkout.discount_code +'">');
  //                 $(data.checkout.line_items).each(function(i,v){
  //                   if(data.checkout.line_items[i].applied_discounts.length == 0){
  //                     $('#mini-cart .line-item[data-cart-item-key="'+v.variant_id+'-'+i+'"] .line-item__discount-list').remove();
  //                   }
  //                   if(data.checkout.line_items[i].discount_allocations.length > 0){
  //                     var linetotaldiscount = 0.00;
  //                     $(data.checkout.line_items[i].discount_allocations).each(function(i,e){
  //                       linetotaldiscount += parseFloat(e.amount);
  //                     });
  //                     var final_price = data.checkout.line_items[i].line_price - linetotaldiscount;
  //                     final_price = final_price * 100;
  //                     var saleprice = final_price / 100;
  //                     var regularprice = data.checkout.line_items[i].line_price;
  //                     // console.log('saleprice',saleprice);
  //                     // console.log('regularprice',regularprice);
  //                     var percentoff = (regularprice - saleprice) * 100 / regularprice;
  //                     // console.log('Percent Off:', percentoff)
  //                     var percentoffFormatted = Math.round(percentoff) + '%';
  //                     var pricehtml = `<span class="price price--highlight">
  //                       <span class="visually-hidden">Sale price</span>${formatMoney(final_price, currencyFormat)}</span><span class="price price--compare">
  //                       <span class="visually-hidden">Regular price</span>${formatMoney(data.checkout.line_items[i].line_price, currencyFormat)}<span class="label label--highlight">${percentoffFormatted}</span>
  //                     </span>`;
  //                     // console.log('sdfd',v.variant_id+'-'+i);
  //                     $('#mini-cart .line-item[data-cart-item-key="'+v.variant_id+'-'+i+'"] .price-list').html(pricehtml);
  //                   }
  //                 });
  //                 $('.discount-price-wrapper').find('.discount-price,.total-price,.shipping-total').show();
  //                 $('.discount-price-wrapper .sub-total .price').html(formatMoney(data.checkout.total_line_items_price, currencyFormat));
  //                 $('.discount-price-wrapper .discount-price .price').html('- '+ formatMoney(data.checkout.total_line_level_discount, currencyFormat));
  //                 $('.discount-price-wrapper .total-price .price').html(formatMoney(data.checkout.total_price, currencyFormat));
  //                 var html = 'Your discounted code *'+ data.checkout.discount_code +'* is successfully applied!';                                    
  //                 $('.discount-code-apply-wrapper .success-msg').show().html(html);                  
  //                 // console.log(data.checkout.discount_code);
  //                 _this.attr('id','remove_code_btn').find('span').text('Remove discount');
  //                 _this.removeAttr('disabled');
  //                 _this.removeClass('loading');
  //                 setCookie('discountcode',data.checkout.discount_code,100000);
  //                   // var maxheight = parseInt($('.cart__footer').outerHeight()) + parseInt($('.shipping-notes-wrapper').outerHeight()) + parseInt($('.cart_heading').outerHeight());                    
  //                 // $('.cart-top').css('max-height','calc(100vh - 400px)');                 
  //               }else{
  //                 // console.log(data);
  //                 $('.discount-code-apply-wrapper').find('.success-msg').hide();
  //                 $('.discount-price-wrapper').find('.discount-price,.total-price').hide();
  //                 $('.err-msg').hide();
  //                 $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.');
  //                 _this.removeAttr('disabled');                                    
  //                 _this.removeClass('loading');                  
  //                 setCookie('discountcode',false,-1);                   
  //               }                
  //             }
  //           });
  //        }); 
  //     });    
  //   }
  // });

  if($('product-sticky-form').length > 0 && $(window).width() < 1000){
    $(window).scroll(function() {
      var scrollDistance = 200;
      if ($(this).scrollTop() > scrollDistance) {
        $('product-sticky-form').addClass('forcevisible');
      } else {
        $('product-sticky-form').removeClass('forcevisible');
      }
    }); 
  }  

  // $('body').on('click','#remove_code_btn',function(e){
  //   var _this = $(this);
  //   _this.addClass('loading');
  //   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //     bubbles: true
  //   }));
  //   _this.attr('id','discount_code_btn').find('span').text('Apply discount');
  //   _this.removeAttr('disabled');                                    
  //   _this.removeClass('loading');                  
  //   setCookie('discountcode',false,-1);     
  // });

  // document.addEventListener('variant:changed', function(event) {
  //   let variant = event.detail.variant; // Gives you access to the whole variant details
  //   let form = event.target;
  //   console.log(variant);
  //   if(variant.featured_media){
  //    if(variant.featured_media.alt != 'visible'){
  //       console.log('variant');
  //       const newSlideHTML = $('.mediawrapper[data-mediaid="'+variant.featured_media.id+'"]').html();
  //       const productMediaInstance = document.querySelector("product-media");
  //       productMediaInstance.prependSlide(newSlideHTML, variant);
  //     }     
  //   }    
  // });

  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail.variant;
    const carouselSelector = "product-media .product__media-list"; // Replace with your carousel selector
    const thumbnailsSelector = "product-media .product__thumbnail-list-inner"; // Replace with your thumbnails selector
  
    window.updateVariantImageInSlider(carouselSelector, thumbnailsSelector, variant);
  });

  // document.addEventListener('minidrawer:update', function(event) {     
  //   console.log('hihhih',event);
  //   if(event.detail.detail){
  //     var cart = event.detail.detail;
  //     if(cart.cart_level_discount_applications.length > 0 && cart.cart_level_discount_applications[0].type == 'discount_code' && !getCookie('discountcode')){
  //       console.log('innnnn');
  //       // setCookie('discountcode',cart.cart_level_discount_applications[0].title,100000);
  //       $('.discount-code-apply-wrapper').find('.discount-code').val(cart.cart_level_discount_applications[0].title);
  //       $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');    
  //       $('.cart-discont-input button,.discount-code-apply-wrapper .discount_err,.discount-code-apply-wrapper .discount-wrapper-select').hide();
  //       $('.discount-code-apply-wrapper .discount-code').attr('readonly', true);
  //       $('.discount-code-apply-wrapper .success-msg').after('<p class="stuckerr">If you have come back to the cart after going to the checkout page you can only change the discount on the checkout page</p>');
  //       setTimeout(function(){
  //         setCookie('discountcode',false,-1); 
  //       },1000)        
  //     }else if(getCookie('discountcode')){
  //       $('.discount-code-apply-wrapper').find('.discount-code').val(getCookie('discountcode'));
  //       $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
  //     }
  //   }else{
  //     $.getJSON('/cart.js', function(cart){
  //       if(cart.cart_level_discount_applications.length > 0 && cart.cart_level_discount_applications[0].type == 'discount_code' && !getCookie('discountcode')){
  //         console.log('innnnn');
  //         // setCookie('discountcode',cart.cart_level_discount_applications[0].title,100000);
  //         $('.discount-code-apply-wrapper').find('.discount-code').val(cart.cart_level_discount_applications[0].title);
  //         $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');    
  //         $('.cart-discont-input button,.discount-code-apply-wrapper .discount_err,.discount-code-apply-wrapper .discount-wrapper-select').hide();
  //         $('.discount-code-apply-wrapper .discount-code').attr('readonly', true);
  //         $('.discount-code-apply-wrapper .success-msg').after('<p class="stuckerr">If you have come back to the cart after going to the checkout page you can only change the discount on the checkout page</p>');
  //         setTimeout(function(){
  //           setCookie('discountcode',false,-1); 
  //         },1000)        
  //       }else if(getCookie('discountcode')){
  //         $('.discount-code-apply-wrapper').find('.discount-code').val(getCookie('discountcode'));
  //         $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
  //       }                  
  //     });
  //   }    
  // });

  if($('[createCustomerForm]').length > 0){
   $('body').on('submit','[createCustomerForm]', function (e) {
      e.preventDefault(); // Prevent form submission
       var _this = $(this);
     _this.find('.banner--success,.banner--error').hide();
      const phone = '91'+_this.find('#phone').val();
      const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format
  
      // Basic Validation
      if (!phoneRegex.test(phone)) {
        _this.find('.banner--error').show().find('.banner__content').html("Please enter a valid 10 digit number without any space.");
        return;
      }
  
      $.ajax({
        url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
        method: "POST",
        contentType:"application/json",
        headers: {
          "Authorization": "9d0e24f04a754d4c8cf069c2e619614a"
        },
        data: JSON.stringify({
          phone: phone,
          tag: 'hush newsletter'
        }),
        success: function (response) {
          console.log(response);
          if(response.status == 1){
            _this.find('.banner--success .banner__content').html(response.message);
            _this.find('.banner--success').show();  
          }else{
            _this.find('.banner--error .banner__content').html(response.message);
            _this.find('.banner--error').show();
          }
          
        },
        error: function (xhr, status, error) {
          console.log(xhr, status, error);
          _this.find('.banner--error').show();
        }
      });
                   
    }); 
  }  
});